import { createApp } from "vue";
import App from "./App.vue";

import "./assets/index.css";
import "@vue-flow/core/dist/style.css";
import "@vue-flow/core/dist/theme-default.css";
import "@vue-flow/controls/dist/style.css";
import { createAppRouter } from "./router";

import tippy, { type Instance, type Placement } from "tippy.js";

async function bootstrap() {
  const app = createApp(App);

  app.directive("tooltip", {
    created: (el, { value, modifiers }) => {
      let placement: Placement = "auto";
      if (modifiers.right) {
        placement = "right";
      }
      if (modifiers.left) {
        placement = "left";
      }
      if (modifiers.top) {
        placement = "top";
      }
      if (modifiers.bottom) {
        placement = "bottom";
      }

      let theme = "";
      if (modifiers.light) {
        theme = "light";
      }
      if (modifiers.error) {
        theme = "error";
      }
      el.$tippy = tippy(el, {
        content: value,
        maxWidth: 500,
        placement,
        interactive: !modifiers.transient,
        theme,
        zIndex: 999999999999999,
        allowHTML: true,
        appendTo: () => {
          const main = document.querySelector("#app");
          if (main) {
            return main;
          } else {
            return document.body;
          }
        },
      });
      if (!value) {
        (el.$tippy as Instance).disable();
      }
    },
    updated: (el, { value }) => {
      (el.$tippy as Instance).setContent(value);
      if (!value) {
        (el.$tippy as Instance).disable();
      } else {
        (el.$tippy as Instance).enable();
      }
    },
    beforeUnmount(el) {
      (el.$tippy as Instance).destroy();
    },
  });

  const router = createAppRouter();
  app.use(router);

  app.mount("#app");
}

bootstrap();
